import React, { useState } from 'react';
import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-react';

function CreateModModal({ onClose, onCreate }) {
  const { getAccessTokenSilently } = useAuth0();
  const [formData, setFormData] = useState({
    modName: '',
    modVersion: '',
    gameVersion: '',
    squadFileLink: '',
    modLink: '',
    game: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCreate = async () => {
    const token = await getAccessTokenSilently();
    await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/mods`, formData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    onCreate(); // To refresh the mods list
    onClose();  // Close the modal
  };

  return (
    <div className="modal">
      <h3>Create New Mod</h3>
      <label>
        Game:
        <input name="game" value={formData.game} onChange={handleChange} />
      </label>
      <br/>
      <label>
        Mod Name:
        <input name="modName" value={formData.modName} onChange={handleChange} />
      </label>
      <br/>
      <label>
        Mod Version:
        <input name="modVersion" value={formData.modVersion} onChange={handleChange} />
      </label>
      <br/>
      <label>
        Game Version:
        <input name="gameVersion" value={formData.gameVersion} onChange={handleChange} />
      </label>
      <br/>
      <label>
        Squad File Link:
        <input name="squadFileLink" value={formData.squadFileLink} onChange={handleChange} />
      </label>
      <br/>
      <label>
        Mod Link:
        <input name="modLink" value={formData.modLink} onChange={handleChange} />
      </label>
      <br/>

      <button onClick={handleCreate}>Create</button>
      <br/>
      <button onClick={onClose}>Cancel</button>
    </div>
  );
}

export default CreateModModal;
